import { CloseOutlined, DeleteOutlined, EditOutlined, PlusOutlined, SettingOutlined } from "@ant-design/icons"
import { Button, Modal, Switch } from "antd"
import { useEffect, useState } from "react"
// import ModalAddTarget from "./ModalAddTarget"
import { checkDisabledPermission, getUserPermissions } from "../../../../until"
import { useSelector } from "react-redux"
import { selectorPermission } from "../../../../store/slices/permissionSlice"
import useToast from "../../../../hook/useToast"
import useLoading from "../../../../hook/useLoading"
import ModalDeleteManager from "../../../../components/ModalDeleteManager"
import { delTarget, getInfoTarget, getListTarget, ITarget } from "../../../../api/target/targetApi"
import useThrottle from "../../../../hook/useThrottle"
import ModalSetPoint from "./ModalSetPoint"
// import ModalUpdateTarget from "./ModalUpdateTarget"

interface ModalProps {
    isOpen: boolean
    closeModal: () => void
}
const ModalScoringRules: React.FC<ModalProps> = ({
    isOpen, closeModal
}) => {


    useEffect(() => {
        gSLTarget()

    }, [])


    const pushToast = useToast();
    const pushLoading = useLoading()
    const permissionSlice = useSelector(selectorPermission)
    const { add, edit, delete: isDelete, upload, download, share, } = getUserPermissions(permissionSlice, location.pathname)

    const [isModalSetPoint, setIsModalSetPoint] = useState(false)

    const [isModalAddTarget, setIsModalAddTarget] = useState(false)
    const [isModalUpdateTarget, setIsModalUpdateTarget] = useState(false)
    const [isModalDeleteTarget, setIsModalDeleteTarget] = useState(false)

    const [sLTarget, setSLTarget] = useState<ITarget[]>([])
    const [infoTarget, setInfoTarget] = useState<ITarget>()

    const [id, setId] = useState<number>()


    const gSLTarget = async () => {
        const result = await getListTarget()
        if (result?.status) {
            setSLTarget(result.data)
        } else {
            pushToast(result?.message, "warning")
        }
    }

    const gInfoTarget = useThrottle(async (id: number, isview: boolean = true) => {
        pushLoading(true)
        const result = await getInfoTarget(id)
        if (result?.status) {
            setInfoTarget(result.data)
            openModalUpdate(result.data.id)
        } else {
            pushToast(result?.message, "warning")
        }
        pushLoading(false)
    }, 1000)

    const onSubmitFormModalAdd = (iSsuccess: boolean, message?: string) => {
        if (iSsuccess) {
            setIsModalAddTarget(false)
            pushToast(message, "success")
            gSLTarget()
        } else {
            pushToast(message, "error")
        }
    }

    const openModalUpdate = (id: number) => {
        setId(id)
        setIsModalUpdateTarget(true)
    }

    const closeModalUpdate = () => {
        setId(undefined)
        setIsModalUpdateTarget(false)
    }


    const onSubmitFormModalUpdate = (iSsuccess: boolean, message?: string) => {
        if (iSsuccess) {
            setIsModalUpdateTarget(false)
            pushToast(message, "success")
            gSLTarget()
        } else {
            pushToast(message, "error")
        }
    }

    const openModalDelete = (id: number) => {
        setId(id)
        setIsModalDeleteTarget(true)
    }

    const closeModalDelete = () => {
        setId(undefined)
        setIsModalDeleteTarget(false)
    }


    const onConfirmDelete = async () => {
        console.log(id)
        if (!id) return
        const result = await delTarget(id)
        if (result?.status) {
            pushToast(result.message, "success")
            closeModalDelete()
            gSLTarget()
        } else {
            pushToast(result?.message, "warning")
        }
    }



    return (
        <Modal
            title={<div className="bg-FCFCFD d-flex justify-betweeen align-center py-4 px-4 w-full border-b-F0F0F0 rounded-2 overflow-hidden">
                <span className="text-base text-344054 fw-500 font-medium">Quy tắc tính điểm</span>
                <CloseOutlined className="text-base text-8B8B8B" onClick={closeModal} />
            </div>}
            open={isOpen}
            onCancel={closeModal}
            centered
            className="custom-page-css w-modal modal-content-warning ant-modal-size rounded-2"
            closeIcon={false}
            footer={''}
        >
            <ModalSetPoint
                isOpen={isModalSetPoint}
                closeModal={() => setIsModalSetPoint(false)}

            />

            {/* <ModalAddTarget
                isOpen={isModalAddTarget}
                onSubmitFormModal={onSubmitFormModalAdd}
                closeModal={() => setIsModalAddTarget(false)}
            />

            <ModalUpdateTarget
                isOpen={isModalUpdateTarget}
                infoTarget={infoTarget}
                onSubmitFormModal={onSubmitFormModalUpdate}
                closeModal={closeModalUpdate}
            /> */}
            <ModalDeleteManager
                isOpen={isModalDeleteTarget}
                title="Bạn có chắc chắn xóa mục tiêu này"
                titleDelete="Xóa mục tiêu"
                content="Mục tiêu và dữ liệu liên quan sẽ bị xóa vĩnh viễn không thể khôi phục"
                closeModal={closeModalDelete}
                onConfirm={onConfirmDelete}
            />

            <div className="custom-page-css flex flex-col gap-2 rounded-2"
                style={{
                    maxHeight: '70vh',
                    overflowY: 'scroll'
                }}
            >
                <div className="custom-page-css flex flex-col gap-2  ">
                    <div className="custom-page-css flex items-center justify-between bg-EEEEEE py-2 px-4">
                        <Button className="custom-page-css text-096DD9 border-096DD9"
                            onClick={() => setIsModalAddTarget(true)}
                        >
                            <span>Thêm</span>
                            <PlusOutlined />
                        </Button>
                        <div className="custom-page-css rounded py-1 px-2 cursor-pointer"
                            style={{
                                border: '1px solid #D9D9D9'
                            }}
                            onClick={() => setIsModalSetPoint(true)}
                        >
                            <SettingOutlined />
                        </div>
                        <span className="custom-page-css text-sm font-medium text-4B4B4B">Hành động</span>

                    </div>
                </div>
                <div className="custom-page-css flex flex-col gap-2  py-2 px-4 h-full">
                    <div
                        // key={item.id}
                        className="custom-page-css flex items-center justify-between"
                    >
                        <span
                            className={`custom-page-css text-sm  px-2 py-1 rounded font-medium`}
                        >Mua xe mới</span>
                        <div className="custom-page-css flex items-center gap-2">
                            <Switch size="small" disabled={edit} />
                            <div
                                className={`custom-page-css flex items-center justify-center p-1 border rounded cursor-pointer ${checkDisabledPermission(edit)}`}
                            // onClick={() => gInfoTarget(item.id)}
                            >
                                <EditOutlined />
                            </div>
                            <div
                                className={`custom-page-css flex items-center justify-center p-1 border rounded cursor-pointer text-FF4D4F ${checkDisabledPermission(isDelete)}`}
                            // onClick={() => openModalDelete(item.id)}
                            >
                                <DeleteOutlined />
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </Modal>
    )
}
export default ModalScoringRules
